"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PLLogo;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _logoHooks = require("@ux/logo-hooks");
var _link = _interopRequireDefault(require("@ux/link"));
// Regex for whitespace and non-typographical unicode characters
// eslint-disable-next-line no-control-regex
var WHITESPACE_REGEX = /[\s\u0000-\u001F\u007F-\u009F]/g;

/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
function PLLogo(props) {
  var figClass = props.figClass,
    privateLabelName = props.privateLabelName,
    _props$logos = props.logos,
    logos = _props$logos === void 0 ? {} : _props$logos,
    _props$urlArgs = props.urlArgs,
    urlArgs = _props$urlArgs === void 0 ? {} : _props$urlArgs,
    href = props.href,
    onClick = props.onClick,
    className = props.className;
  var url = (0, _logoHooks.useMobile)(props) ? logos.mobile : logos.desktop;
  var imgSrc = (url || '').replace(WHITESPACE_REGEX, '');

  //
  // If no URL for a custom logo has been provided then display
  // the name of the private label. Make it a link if it also has a href.
  //
  if (!imgSrc) {
    return href ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
      className: (0, _classnames["default"])(className, 'logo-text'),
      id: "registrar",
      urlArgs: urlArgs,
      "data-eid": props['data-eid'],
      onClick: onClick,
      rel: "nofollow",
      href: (0, _logoHooks.updateQuery)(href, urlArgs)
    }, " ", privateLabelName) : /*#__PURE__*/_react["default"].createElement("span", {
      id: "registrar",
      className: "logo-text"
    }, privateLabelName);
  }

  // To prevent SVGs from rendering 0x0, set an arbitrarily large enough width
  // to cover the max-width of the span. Only appropriate for SVGs because
  // other image types would stretch if their aspect ratio is narrower than
  // the span's.
  var svgHack = /\.svg$/.test(imgSrc) && {
    width: 200
  };
  var logo = /*#__PURE__*/_react["default"].createElement("figure", {
    className: (0, _classnames["default"])('logo-img', figClass),
    style: {
      margin: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    id: "registrar",
    src: encodeURI(imgSrc),
    alt: privateLabelName
  }, svgHack)));
  return href ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    className: (0, _classnames["default"])(className, 'white-logo-bg'),
    urlArgs: urlArgs,
    "data-eid": props['data-eid'],
    onClick: onClick,
    rel: "nofollow",
    href: (0, _logoHooks.updateQuery)(href, urlArgs)
  }, logo) : logo;
}
PLLogo.propTypes = {
  /** CSS class name to apply to the outer link */
  'className': _propTypes["default"].string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': _propTypes["default"].bool,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': _propTypes["default"].string,
  /** href to pass to Link component */
  'href': _propTypes["default"].string,
  /** An object with desktop and mobile logo source links */
  'logos': _propTypes["default"].shape({
    desktop: _propTypes["default"].string,
    mobile: _propTypes["default"].string
  }),
  /** Callback for a click on the logo link */
  'onClick': _propTypes["default"].func,
  /** The reseller's private label name shown under the logo image or when no logos provided */
  'privateLabelName': _propTypes["default"].string.isRequired,
  /** CSS class name to apply to wrapping `figure` element */
  'figClass': _propTypes["default"].string,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': _propTypes["default"].object
};